import React from 'react';
import classes from './styles/index.module.scss';
import { useStyleContextState } from '../../../styleContext';
import { useUserPageContextState } from '../../../user';
import { getDashboardPageUrl } from '../../const';
import RouteLink from '../../../../components/RouteLink';

const HeaderLogo = () => {
	const {
		logo: { imageUrl, location },
	} = useStyleContextState();
	const { isAuthenticated } = useUserPageContextState();

	return (
		<RouteLink
			href={isAuthenticated ? getDashboardPageUrl() : location}
			hasColor={false}
			className={classes.logo}
			useDirty
		>
			{imageUrl && imageUrl.length > 0 && (
				<img
					src={imageUrl}
					className={classes.image}
					alt='logo'
				/>
			)}
		</RouteLink>
	);
};

export default HeaderLogo;
